import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import uniqBy from 'lodash.uniqby';
import MediaQuery from 'react-responsive';
import classNames from 'classnames';
import { FilterBox, InputTextFuzzy, Icon } from '@massds/mayflower-react';

import { slugify, getObjByValue } from '../../utils';
import './index.scss';

class TaxFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterBoxExpanded: false
    };
  }

  toggleFilterBox = () => {
    this.setState((prevState) => ({ filterBoxExpanded: !prevState.filterBoxExpanded }));
  };

  render() {
    const { filter, location } = this.props;
    const { filterBoxExpanded } = this.state;
    const pathName = location.pathname.replace(process.env.GATSBY_PATH_PREFIX, '');
    const [, path, typePath = '', expenditurePath = '', itemPath = ''] = pathName.split('/');
    let selectedType = null;
    const taxTypes = uniqBy(filter.data, 'taxType')
      .map((item) => {
        const value = item.taxType;
        const slug = slugify(value);
        if (slug === typePath) selectedType = value;
        return{
          text: value,
          value: `/${path}/${slug}`
        };
      });
    const typeProps = {
      label: 'Tax Type',
      id: 'tax-type',
      inputId: 'tax-type-input',
      options: taxTypes,
      selected: selectedType,
      keys: ['text'],
      placeholder: 'All Tax Types',
      onSuggestionClick: (e, { suggestion }) => {
        e.preventDefault();
        const { value } = getObjByValue(taxTypes, suggestion.item.text, 'text');
        if (value && value.length > 0) navigate(value);
      },
      onChange: ({ value }) => {
        if (value === '') {
          navigate(path);
        }
      }
    };
    let selectedExpenditure = null;
    let expenditurePlaceHolder = 'All Tax Expenditure';
    const existing = [];
    const taxExpenditures = filter.data
      .filter((item) => {
        const i = Math.round(item.taxItemNumber * 10);
        if (existing.includes(i)) return false;
        existing.push(i);
        return true;
      })
      .filter((item) => !(typePath && slugify(item.taxType) !== typePath))
      .map((item) => {
        const value = item.taxExpenditure;
        const slug = slugify(value);
        if (slug === expenditurePath) selectedExpenditure = value;
        if (typePath) expenditurePlaceHolder = `All ${item.taxType} Expenditure`;
        return{
          text: item.taxExpenditure,
          type: slugify(item.taxType),
          value: slug
        };
      });
    const expenditureProps = {
      label: 'Type Expenditure',
      id: 'type-expenditure',
      inputId: 'type-expenditure-input',
      options: taxExpenditures,
      selected: selectedExpenditure,
      keys: ['text'],
      placeholder: expenditurePlaceHolder,
      onSuggestionClick: (e, { suggestion }) => {
        e.preventDefault();
        const { value, type } = getObjByValue(taxExpenditures, suggestion.item.text, 'text');
        let url = `/${path}/${type || typePath}`;
        if (value && value.length > 0) {
          url += `/${value}`;
          navigate(url);
        }
      },
      onChange: ({ value }) => {
        if (value === '') {
          const url = `/${path}/${typePath}`;
          navigate(url);
        }
      }
    };
    let selectedItem = null;
    const taxItems = filter.data.map((item) => {
      const slug = slugify(item.taxItemNumber);
      if (slug === itemPath) selectedItem = `${item.taxItemNumber} - ${item.taxItemName}`;
      return{
        value: `/${path}/${slugify(item.taxType)}/${slugify(item.taxExpenditure)}/${slugify(item.taxItemNumber)}`,
        text: `${item.taxItemNumber} - ${item.taxItemName}`
      };
    });
    const searchProps = {
      label: 'Search for Tax Item',
      id: 'tax-search',
      inputId: 'tax-search-input',
      options: taxItems,
      selected: selectedItem,
      keys: ['text'],
      placeholder: 'eg: 03200003',
      onSuggestionClick: (e, { suggestion }) => {
        e.preventDefault();
        if (suggestion) {
          // If the user chose a suggestion, value will be set on the suggestion object.
          // Otherwise, text only will be set.
          const { item: { value } } = suggestion;
          if (value && value.length > 0) navigate(value);
          // If the user types an exact match, navigate should still work.
          else if (selectedItem.length > 0) {
            const taxItem = getObjByValue(taxItems, selectedItem, 'text');
            if (taxItem) navigate(taxItem.value);
          }
        }
      }
    };
    const filterProps = {
      fields: [
        {
          class: 'ma__filter-box',
          component: <InputTextFuzzy {...typeProps} />
        },
        {
          class: 'ma__filter-box',
          component: <InputTextFuzzy {...expenditureProps} />
        },
        {
          class: 'ma__filter-box ma__filter-box--search',
          component: <InputTextFuzzy {...searchProps} />
        }
      ],
      submitButton: null,
      clearButton: null,
      filterLabel: 'Search for a tax type, tax expenditure, or tax item.',
      filterNote: "As you select an option, you'll be automatically redirected to the page you select."
    };
    const toggleButtonClasses = classNames({
      'ma__search-banner__filter-box-toggle': true,
      'ma__search-banner__filter-box-toggle--expanded': filterBoxExpanded
    });
    const filterToggleText = filterBoxExpanded ? 'Hide Search Options' : 'Search by Tax Type or Tax Item';
    return(
      <MediaQuery minDeviceWidth={910}>
        {
          (matches) => {
            if (!matches) {
              return(
                <Fragment>
                  <div className="main-content--two ma__search-banner__filter-box-toggle-container">
                    <button
                      onClick={this.toggleFilterBox}
                      type="button"
                      className={toggleButtonClasses}
                      aria-expanded={filterBoxExpanded}
                    >
                      {filterToggleText}
                      <Icon name="chevron" svgWidth={20} svgHeight={20} />
                    </button>
                  </div>
                  {filterBoxExpanded && <FilterBox {...filterProps} />}
                </Fragment>
              );
            }
            return(<FilterBox {...filterProps} />);
          }
        }
      </MediaQuery>
    );
  }
}

TaxFilter.propTypes = {
  /** Filter data */
  filter: PropTypes.object,
  /** Location object from pages props. */
  location: PropTypes.object
};

export default TaxFilter;
